import type { PaginationProps } from 'antd';

export const getPaginationItemRenderWithDataTestIds: PaginationProps['itemRender'] =
  (_, type, originalElement) => {
    switch (type) {
      case 'prev':
        return <span data-testid="back-pagination">{originalElement}</span>;
      case 'next':
        return <span data-testid="forward-pagination">{originalElement}</span>;
      case 'page':
        return <span data-testid="pagination-page">{originalElement}</span>;
      default:
        return originalElement;
    }
  };
